<ng-template [vbCssRules]="themeStyleOverrides"></ng-template>

<div [ngClass]="styles.authShell" class="theme-header-bg theme-header-txt">
	<div [ngClass]="styles.content">
		<ng-content></ng-content>
	</div>
</div>